<template>
  <el-dialog
    :title="$t('housekeepingResource.deleteConfirm')"
    :visible.sync="visible"
    width="30%"
    center
  >
    <div style="text-align:center">
      <p>{{ $t('housekeepingResource.deleteResourceTip') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="deleteHousekeepingResource">{{ $t('common.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteHousekeepingResource } from '@/api/housekeepingResource/housekeepingResourceApi'

export default {
  name: 'DeleteHousekeepingResource',
  data() {
    return {
      visible: false,
      deleteHousekeepingResourceInfo: {}
    }
  },
  methods: {
    open(row) {
      this.visible = true
      this.deleteHousekeepingResourceInfo = { ...row }
    },
    closeDialog() {
      this.visible = false
      this.deleteHousekeepingResourceInfo = {}
    },
    async deleteHousekeepingResource() {
      try {
        await deleteHousekeepingResource(this.deleteHousekeepingResourceInfo)
        this.$emit('refresh')
        this.$message.success(this.$t('common.submitSuccess'))
        this.closeDialog()
      } catch (error) {
        this.$message.error(error)
        console.error(error)
      }
    }
  }
}
</script>